// ---  IMPORTS --- //
import flatProperties from '@/config/flatConfig';
import BalticWave from '@/config/investments/balticwave';

// ---  VARIABLES --- //

let INVESTENTS = new Map();

INVESTENTS.set(BalticWave.url, BalticWave);

// ---  CONFIG --- //

const CONFIG = {
  flatsOnPage: 6, // Amount of flats on single list page.

  // Directories (names of folders)
  flatsPlansDir: '2D',
  flats3DDir: '3D',
  buildingsDir: 'buildings',
  PDFsDir: 'PDF',
  // End of directories

  lazySlider: false, // As for default the value will only be updated when the drag is over (https://nightcatsama.github.io/vue-slider-component/#/basics/simple?hash=lazy)

  flatProperties: flatProperties,
  investments: INVESTENTS,
};

// --- End of CONFIG --- //

export default CONFIG;
